import { useState } from 'react';
import showToast from '../components/ToastComponent';
import instance from '../config/axios';
import Breadcrumbs from '../components/Breadcrumbs';
import { useAuth } from 'react-oidc-context';

const ResetPasswordMail = () => {
  const [email, setEmail] = useState('');
  const [isMailSend, setMailSendStatus] = useState<boolean>(false);
  const { user } = useAuth();

  const sendResetPasswordEmail = () => {
    if (!email) {
      showToast({
        message: 'Email may not to be empty',
        type: 'warning',
      });
      return;
    }

    instance
      .post(
        '/api/v1/reset-password-link',
        {
          email,
        },
        {
          headers: {},
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setMailSendStatus(true);
        } else {
          showToast({
            message: 'Failed to send email',
            type: 'error',
          });
        }
      });
  };

  return (
    <>
      <Breadcrumbs
        data={[
          {
            tag: 'a',
            className: 'mr-3',
            href: `${user?.access_token ? '/home' : '/'}`,
            children: <>Home</>,
          },
          {
            tag: 'p',
            children: <span>Forgot Password</span>,
          },
        ]}
      />
      <div className=" px-6 py-8 sm:py-16 lg:px-8">
        <div className="mx-auto max-w-2xl">
          {!isMailSend ? (
            <>
              <p className="text-center text-xl lg:text-2xl text-primary-blue-500 font-regular mt-2 lg:mt-0">
                Enter your email to reset your password
              </p>
              <div className="mt-7 text-lg leading-8 text-gray-600 ">
                <div className="relative mt-2 rounded-md shadow-sm w-4/4 md:w-3/4 mx-auto">
                  <input
                    type={'text'}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                    id="email"
                    className="text-sm font-regular border  
                    rounded-md p-2 w-full p-3
                    focus:border-primary-blue-500"
                    placeholder="Email"
                  />
                </div>

                <div className="text-center">
                  <button
                    type="button"
                    className="mt-10 rounded-md bg-secondary-cornflowerblue-600 px-10 py-2 text-center text-sm font-semibold text-white"
                    onClick={() => sendResetPasswordEmail()}
                  >
                    Send email
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div>
              <p className="text-center text-xl lg:text-2xl text-primary-blue-500 font-regular mt-2 lg:mt-0">
                Email successfully sent. Please check your inbox and follow the
                instructions to reset your password.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default ResetPasswordMail;
